import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        role: '='
    },
    template: `
        <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
        <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="!vm.list.loading && vm.list.items.length">
            <thead>
            <tr>
                <th>{{ 'manage.User' | translate }}</th>
                <th>{{ 'manage.Sites' | translate }}</th>
                <th>{{ 'user.Status' | translate }}</th>
            </tr>
            </thead>
            <tbody>
                <tr ng-repeat="item in vm.list.items">
                    <td>
                        <a ui-sref="authorized.manage.permissions.users.detail.sites({ id: item.id})">{{ item.displayName }}</a>
                    </td>
                    <td>
                        <span ng-repeat="site in item.sites">
                            <a ui-sref="authorized.manage.permissions.sites.detail( { id: site.id})">{{ site.name }}</a>
                            <span ng-show="!$last ">, </span>
                        </span>
                    </td>
                    <td>{{ vm.USER_STATUS_ENUM.LABELS[item.status] }}</td>
                </tr>
            </tbody>
        </table>
    `
})
export default class {
    constructor (DATATABLES, USER_STATUS_ENUM, UserResource, ListFactory) {
        this.DATATABLES = DATATABLES;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.list = ListFactory.createWithoutPagination(UserResource.query.bind(UserResource));
        this.list.fetch({ roleId: this.role.id, expand: 'sites' });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/manage/permissions/roles/detail/users/index.js